import "./registerServiceWorker";
import {rehydrateStore, store} from "./store";
import ElementPlus from "element-plus";
import {ElMessage} from "element-plus";
import eventBus from "@/modules/event-bus";
import appMixin from "@/extensions/app-mixin";

import { createApp } from "vue";
import App from "./App.vue";
import router, {setRouteGuardReadyPromise} from "./router";
import keycloak from "@/auth/keycloak";
import esquireClient from "@/modules/esquire-client";
import { userContext, initializeStore } from "@/store";

async function prepareAuthenticatedStore(token: string, refreshToken: string): Promise<void> {
    esquireClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    await userContext.actions.setKeycloakSession({
        token,
        refreshToken,
        authenticated: true
    });

    await rehydrateStore();
}

async function initializeAuthenticatedStore(preparedStorePromise: Promise<void>): Promise<void> {
    await preparedStorePromise;

    await initializeStore();
}

async function bootstrap(): Promise<void> {
    try {
        const authenticated = await keycloak.init({
            onLoad: "login-required",
            checkLoginIframe: false,
            pkceMethod: "S256"
        });

        let routeGuardReadyPromise: Promise<void> = Promise.resolve();
        let storeReadyPromise: Promise<void> = Promise.resolve();

        if (authenticated && keycloak.token) {
            routeGuardReadyPromise = prepareAuthenticatedStore(keycloak.token, keycloak.refreshToken ?? "");
            storeReadyPromise = initializeAuthenticatedStore(routeGuardReadyPromise);
        }

        setRouteGuardReadyPromise(routeGuardReadyPromise);
        routeGuardReadyPromise.catch(console.error);
        storeReadyPromise.catch(console.error);

        // Refresh token automatically before expiry
        setInterval(async () => {
            if (!keycloak.authenticated) return;

            try {
                const refreshed = await keycloak.updateToken(30);
                if (refreshed && keycloak.token) {
                    esquireClient.defaults.headers.common["Authorization"] = `Bearer ${keycloak.token}`;
                    await userContext.actions.updateToken(keycloak.token);
                }
            } catch (err) {
                console.error("Failed to refresh token", err);
                await userContext.actions.logout();
            }
        }, 10000);

        const app = createApp(App);

        app.mixin(appMixin);
        app.config.globalProperties.$events = eventBus;
        app.config.globalProperties.$message = ElMessage;

        app
            .use(store)
            .use(router)
            .use(ElementPlus)
            .mount("#app");

    } catch (err) {
        console.error("App bootstrap failed", err);
    }
}

bootstrap();

